














































import RedirectToLoginOrOldPeak from "@/components/alertPage/RedirectToLoginOrOldPeak.vue";
import AlertComponent from "@/components/element/AlertComponent.vue";
import Footer from "@/components/footer/Footer.vue";
import VideoPlayer from "@/components/footer/VideoPlayer.vue";
import Header from "@/components/header/Header.vue";
import ModalEditDocument from "@/components/modal/DocumentTour/ModalEditDocument.vue";
import ModalProfileLogo from "@/components/modal/DocumentTour/ModalProfileLogo.vue";
import ModalSignature from "@/components/modal/DocumentTour/ModalSignature.vue";
import Passcode from "@/components/passcode/Passcode.vue";
import {
  DocumentTourStatus,
  DocumentType,
  DocumentUpdatePassCodeType,
  FinanceType,
  LoadingStatusType,
  PndType,
  TaxSourceType,
  TransactionType,
  TypeComponentNoti,
} from "@/enums/enums";
import { MerchantId } from "@/helper/authenticationHelper";
import { GetDocumentNameHeader, GetPrefixName } from "@/helper/documentHelper";
import { GetMerchantNameWihtMerchantType } from "@/helper/merchantHelper";
import { ContactEnvelopeOnlineViewModel } from "@/model/document/contactEnvelopeModel";
import {
  DocumentIdModel,
  DocumentWithPassCodeModel,
  OnlineViewCustomizeModel,
  OnlineViewModel,
} from "@/model/document/documentModel";
import { ExecutiveSummaryOnlineViewModel } from "@/model/document/executiveSummaryModel";
import { JournalOnlineViewModel } from "@/model/document/journalDocumentModal";
import { PndOnlineViewModel } from "@/model/document/pndDocumentModel";
import { PP30OnlineViewModel } from "@/model/document/pp30DocumentModel";
import { WitholdingTaxOnlineViewModel } from "@/model/document/witholdingTaxDocumentModal";
import { MerchantModel } from "@/model/merchant/merchantModel";
import { UserModel } from "@/model/user/userModel";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreDocument = namespace("Document");
const StoreAuthentication = namespace("Authentication");
const StoreMerchant = namespace("Merchant");
const StoreAlert = namespace("Alert");

@Component({
  components: {
    Header,
    Footer,
    Passcode,
    AlertComponent,
    RedirectToLoginOrOldPeak,
    VideoPlayer,
    ModalEditDocument,
    ModalProfileLogo,
    ModalSignature,
  },
})
export default class Layout extends Vue {
  @Prop({ default: TransactionType.None }) transactionType!: number;
  @Prop({ default: FinanceType.None }) financeType!: number;
  @Prop({ default: 0 }) transactionId!: number;
  @Prop({ default: "" }) customizeId!: string;
  @Prop({ default: 0 }) sourceType!: number;
  @Prop({ default: "" }) headerTypeCode!: string;
  @Prop({ default: "" }) passCodeUrl!: string;

  private transactionNumber: string = "";
  private documentName: string = "";
  private showAlertMessage: boolean = false;
  private render: boolean = true;
  private passCodeInput: any = null;
  private isAuthorized: boolean = false;
  private copyLink: string = "";
  private merchantFullName: string = "";
  private contactFullName: string = "";
  private link: string = window.location.href;
  private documentPassCode: string = "";
  private isCreatePassCodeAuto: boolean = false;
  private isShowRedirectToLoginOrOldPeak: boolean = false;
  isShowDocumentTourEdit: boolean = false;
  isShowDocumentTourLogo: boolean = false;
  isShowDocumentTourSignature: boolean = false;
  private selectDocumentType = { id: 0, name: "รูปแบบ PEAK" };

  @StoreAuthentication.Getter
  private getUserInfo!: UserModel | null;
  @StoreAuthentication.Getter
  private getIsAuthorized!: boolean;
  @StoreDocument.Getter
  private getDocumentLoadingStatus!: LoadingStatusType;
  @StoreDocument.Getter
  private getDocumentDetail!:
    | OnlineViewModel
    | JournalOnlineViewModel
    | PP30OnlineViewModel
    | WitholdingTaxOnlineViewModel
    | ExecutiveSummaryOnlineViewModel
    | OnlineViewCustomizeModel
    | null;
  @StoreMerchant.Getter
  private getMerchantDetail!: MerchantModel;
  @StoreDocument.Getter
  private getUpdateDocumentLoadingStatus!: LoadingStatusType;
  @StoreDocument.Getter
  private getSetDefaultDocument!: boolean;
  @StoreDocument.Getter
  private getRemoveOnlineViewPassCodeLoadingStatus!: LoadingStatusType;
  @StoreDocument.Getter
  private getUpdateOnlineViewPassCodeLoadingStatus!: LoadingStatusType;
  @StoreDocument.Getter
  private getDocumentName!: string;

  @StoreAlert.Action
  private SetAlertMessage!: (input: any) => void;
  @StoreDocument.Action
  private DoGetDocumentWithPassCode!: (input: DocumentWithPassCodeModel) => void;
  @StoreDocument.Action
  private DoGetDocument!: (input: DocumentIdModel) => void;
  @StoreDocument.Action
  private DoUpdateDocumentDetail!: (input: any) => void;
  @StoreDocument.Action
  private DoSetDefaultDocument!: (setDefaultDocument: boolean) => void;
  @StoreDocument.Action
  private DoUpdateOnlineViewPassCode!: (input: DocumentIdModel) => void;
  @StoreDocument.Action
  private DoGetCustomizeDocument!: (input: any) => void;
  @StoreDocument.Action
  private DoGetCustomizeDocumentPublicLink!: (input: any) => void;
  @StoreDocument.Action
  private DoGetCustomizeIdList!: (input: any) => void;

  @StoreDocument.Mutation
  private SetDocumentName!: (documentName: string) => void;

  created() {
    this.CallDoGetDocumentAction();
    if (this.getIsAuthorized || this.getMerchantDetail.isUsePassCodeOnPublicLink == false) {
      this.isAuthorized = true;
    }
    if (this.getMerchantDetail) {
      this.merchantFullName = GetMerchantNameWihtMerchantType(
        this.getMerchantDetail.merchantType,
        this.getMerchantDetail.merchantName
      );
    }
  }

  get isDocumentNameShort() {
    return (
      this.transactionType === TransactionType.PP30 ||
      this.transactionType === TransactionType.Pnd1 ||
      this.transactionType === TransactionType.Pnd2 ||
      this.transactionType === TransactionType.Pnd3 ||
      this.transactionType === TransactionType.Pnd53
    );
  }

  get isDocumentOtherType() {
    return this.transactionType === DocumentType.Envelope || this.transactionType === DocumentType.ExecutiveSummary;
  }

  @Watch("getSetDefaultDocument")
  getSetDefaultDocumentChanged(newVal: boolean) {
    if (newVal) {
      if (this.passCodeInput) {
        this.CallDoGetDocumentAction(true);
      } else {
        this.CallDoGetDocumentAction();
      }
      this.DoSetDefaultDocument(false);
    }
  }

  @Watch("$route.query.emi")
  queryEmiChange() {
    let urlEmi: any = this.$route.query.emi;
    urlEmi = urlEmi ? urlEmi.PeakDecryption() : null;
    if (urlEmi) {
      if (urlEmi !== MerchantId()) {
        sessionStorage.setItem("emi", urlEmi.PeakEncryption());
        this.$router.go(0);
      }
    }
  }
  @Watch("$route.query", { immediate: true })
  queryTourEditChange() {
    let isShowTourSignature = true;
    let isShowTourLogo = true;
    const userInfo = this.getUserInfo;
    if (this.getDocumentDetail && userInfo) {
      isShowTourLogo = !this.getMerchantDetail.logoUrl;
      const currentUserSignature = this.getDocumentDetail.credential.userCredential.filter(
        (c) => c.userId === userInfo.userId
      );
      isShowTourSignature = !(currentUserSignature.length > 0);
    }
    let { tourEdit, tourLogo, tourSignature } = this.$route.query;
    if (this.$route.name === "receipt" && tourEdit === DocumentTourStatus.Show.toString()) {
      this.isShowDocumentTourEdit = true;
    } else {
      this.isShowDocumentTourEdit = false;
    }
    if (
      this.$route.name === "receipt" &&
      tourLogo === DocumentTourStatus.Show.toString() &&
      tourEdit !== DocumentTourStatus.Edit.toString()
    ) {
      this.isShowDocumentTourLogo = true;
    } else {
      this.isShowDocumentTourLogo = false;
    }
    if (
      this.$route.name === "receipt" &&
      tourSignature === DocumentTourStatus.Show.toString() &&
      tourEdit !== DocumentTourStatus.Edit.toString()
    ) {
      this.isShowDocumentTourSignature = true;
    } else {
      this.isShowDocumentTourSignature = false;
    }
  }
  @Watch("$i18n.locale")
  languageChanged() {
    if (this.getDocumentDetail) {
      this.documentName = GetDocumentNameHeader(this.getDocumentDetail);
      this.SetDocumentName(this.documentName);
    }
  }
  @Watch("getDocumentLoadingStatus")
  getDocumentLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Success) {
      if (this.getDocumentDetail && this.getDocumentDetail.document) {
        if (this.$route.query.passcode) {
          let query = Object.assign({}, this.$route.query);
          delete query.passcode;
          this.$router.replace({ query });
        }
        this.isAuthorized = true;
        this.documentName = GetDocumentNameHeader(this.getDocumentDetail);
        this.SetDocumentName(this.documentName);
        if (this.getDocumentDetail instanceof JournalOnlineViewModel) {
          this.transactionNumber = this.getDocumentDetail.document.data.journalNumber;
          this.contactFullName =
            GetPrefixName(this.getDocumentDetail.document.data.contact.ordinaryPerson) +
            " " +
            GetMerchantNameWihtMerchantType(
              this.getDocumentDetail.document.data.contact.merchantType,
              this.getDocumentDetail.document.data.contact.name
            );
        } else if (this.getDocumentDetail instanceof WitholdingTaxOnlineViewModel) {
          this.transactionNumber = this.getDocumentDetail.document.data.whtNumber;
          this.contactFullName =
            GetPrefixName(this.getDocumentDetail.document.data.contact.ordinaryPerson) +
            " " +
            GetMerchantNameWihtMerchantType(
              this.getDocumentDetail.document.data.contact.merchantType,
              this.getDocumentDetail.document.data.contact.name
            );
        } else if (this.getDocumentDetail instanceof PP30OnlineViewModel) {
          this.transactionNumber = this.getDocumentDetail.document.data.formNumber;
        } else if (this.getDocumentDetail instanceof PndOnlineViewModel) {
          this.transactionNumber = this.getDocumentDetail.document.data.pndNumber;
        } else if (this.getDocumentDetail instanceof ContactEnvelopeOnlineViewModel) {
          this.transactionNumber = this.getDocumentDetail.document.data.contact.contactCode;
          this.contactFullName =
            GetPrefixName(this.getDocumentDetail.document.data.contact.ordinaryPerson) +
            " " +
            GetMerchantNameWihtMerchantType(
              this.getDocumentDetail.document.data.contact.merchantType,
              this.getDocumentDetail.document.data.contact.name
            );
        } else if (this.getDocumentDetail instanceof ExecutiveSummaryOnlineViewModel) {
          this.transactionNumber = this.getDocumentDetail.document.data.executiveSummary.number;
        } else if (this.getDocumentDetail instanceof OnlineViewModel) {
          this.GetCustomizeIdList();
          this.transactionNumber = this.getDocumentDetail.document.data.transactionNumber;
          this.contactFullName =
            GetPrefixName(this.getDocumentDetail.document.data.contact.ordinaryPerson) +
            " " +
            GetMerchantNameWihtMerchantType(
              this.getDocumentDetail.document.data.contact.merchantType,
              this.getDocumentDetail.document.data.contact.name
            );
        } else if (this.getDocumentDetail instanceof OnlineViewCustomizeModel) {
          this.GetCustomizeIdList();
          this.transactionNumber = this.getDocumentDetail.document.data.transactionNumber;
          this.contactFullName =
            GetPrefixName(this.getDocumentDetail.document.data.contact.ordinaryPerson) +
            " " +
            GetMerchantNameWihtMerchantType(
              this.getDocumentDetail.document.data.contact.merchantType,
              this.getDocumentDetail.document.data.contact.name
            );
        }

        this.documentPassCode = this.getDocumentDetail.credential?.passCode
          ? this.getDocumentDetail.credential.passCode
          : "";
        if (this.getMerchantDetail.isUsePassCodeOnPublicLink && this.isCreatePassCodeAuto) {
          this.copyLink += `\nPassCode: ${this.documentPassCode}`;
          this.$copyText(this.copyLink);
          this.isCreatePassCodeAuto = false;
        }
        document.title = `Doc: ${this.transactionNumber}`;

        this.render = false;
        this.$nextTick(() => {
          this.render = true;
          this.queryTourEditChange();
        });
      } else if (!this.customizeId) {
        this.isShowRedirectToLoginOrOldPeak = true;
      }
    } else if (newVal === LoadingStatusType.Fail) {
      this.showAlertMessage = true;
    }
  }
  @Watch("getUpdateDocumentLoadingStatus")
  getUpdateDocumentLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Success) {
      this.CallDoGetDocumentAction();
    }
  }
  @Watch("passCodeInput")
  passCodeChanged(newVal: any) {
    if (newVal) {
      this.CallDoGetDocumentAction(true);
    }
  }
  @Watch("getRemoveOnlineViewPassCodeLoadingStatus")
  getRemoveOnlineViewPassCodeLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Success) {
      this.CallDoGetDocumentAction();
    }
  }
  @Watch("getUpdateOnlineViewPassCodeLoadingStatus")
  getUpdateOnlineViewPassCodeLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Success) {
      this.CallDoGetDocumentAction();
    }
  }

  public CallDoGetDocumentAction(isPassCode: boolean = false) {
    if (this.getIsAuthorized) {
      if (this.customizeId) {
        const input = {
          customizeId: this.customizeId,
          transactionType: this.transactionType,
          financeType: this.financeType,
          transactionId: this.transactionId,
        };
        this.DoGetCustomizeDocument(input);
      } else {
        const input = {
          transactionType: this.transactionType,
          financeType: this.financeType,
          transactionId: this.transactionId,
          sourceType: this.sourceType,
          headerTypeCode: this.headerTypeCode,
        };
        this.DoGetDocument(input);
      }
    } else {
      if (this.customizeId) {
        const input = {
          customizeId: this.customizeId,
          transactionType: this.transactionType,
          financeType: this.financeType,
          transactionId: this.transactionId,
          passCode: this.getMerchantDetail.isUsePassCodeOnPublicLink ? this.passCodeInput : "",
        };
        if (isPassCode || this.getMerchantDetail.isUsePassCodeOnPublicLink == false) {
          this.DoGetCustomizeDocumentPublicLink(input);
        } else if (this.getMerchantDetail.isUsePassCodeOnPublicLink && this.passCodeUrl !== "") {
          input.passCode = this.passCodeUrl;
          this.DoGetCustomizeDocumentPublicLink(input);
        }
      } else {
        let input = {
          transactionType: this.transactionType,
          financeType: this.financeType,
          transactionId: this.transactionId,
          sourceType: this.sourceType,
          passCode: this.getMerchantDetail.isUsePassCodeOnPublicLink ? this.passCodeInput : "",
          headerTypeCode: this.headerTypeCode,
          headerType: 0,
        };
        if (isPassCode || this.getMerchantDetail.isUsePassCodeOnPublicLink == false || this.isDocumentOtherType) {
          this.DoGetDocumentWithPassCode(input);
        } else if (this.getMerchantDetail.isUsePassCodeOnPublicLink && this.passCodeUrl !== "") {
          input.passCode = this.passCodeUrl;
          this.DoGetDocumentWithPassCode(input);
        }
      }
    }
  }

  public GetCustomizeIdList() {
    if (this.getIsAuthorized) {
      const input = {
        transactionType: this.transactionType,
        financeType: this.financeType,
        expenseType: this.getDocumentDetail?.expenseType,
      };
      this.DoGetCustomizeIdList(input);
    }
  }

  public CopyLink() {
    const merchantText = `${this.$t("Merchant")}: ${this.merchantFullName}\nออกเอกสาร: ${this.documentName}\n`;
    const contactText =
      this.transactionType !== DocumentType.ExecutiveSummary ? `ให้กับ: ${this.contactFullName}\n` : "";
    const linkText = `Link: ${this.link}`;
    this.copyLink = merchantText + contactText + linkText;

    if (!this.isDocumentOtherType && this.getMerchantDetail.isUsePassCodeOnPublicLink && this.documentPassCode === "") {
      let input = {
        transactionType: this.transactionType,
        financeType: this.financeType,
        transactionId: this.transactionId,
        sourceType: this.sourceType,
        documentName: this.documentName,
        transactionNumber: this.transactionNumber,
        isDocumentNameShort: this.isDocumentNameShort,
        documentUpdatePassCodeType: DocumentUpdatePassCodeType.CopyLink,
      };
      this.DoUpdateOnlineViewPassCode(input);
      this.isCreatePassCodeAuto = true;
    } else {
      if (
        !this.isDocumentOtherType &&
        this.documentPassCode &&
        this.documentPassCode !== "" &&
        this.getMerchantDetail.isUsePassCodeOnPublicLink
      ) {
        this.copyLink += `\nPassCode: ${this.documentPassCode}`;
      }
      this.$copyText(this.copyLink);
      this.SetAlertMessage({
        alertMessage: this.$t("Alert_Copy_Link_Success", {
          name: (this.isDocumentNameShort ? " " : "") + this.documentName,
          number: this.transactionNumber,
        }),
        typeMessage: TypeComponentNoti.Success,
      });
    }
  }
  public UpdateDocument() {
    let input = {
      transactionType: this.transactionType,
      transactionNumber: this.transactionNumber,
      documentName: this.documentName,
      financeType: this.financeType,
      transactionId: this.transactionId,
      sourceType: this.sourceType,
      updateVersion: false,
    };
    this.DoUpdateDocumentDetail(input);
  }
  public RedirectToOldPeak(replace: boolean = false) {
    let headerType = "";
    let isDailyJournal = false;
    switch (this.transactionType) {
      case TransactionType.Quotation: {
        if (this.financeType === FinanceType.InFlow) {
          switch (this.headerTypeCode) {
            case "QO": {
              headerType = "";
              break;
            }
            case "CUS": {
              headerType = "";
              break;
            }
            case "TDN": {
              headerType = "tdn";
              break;
            }
            default: {
              headerType = "";
            }
          }
        } else if (this.financeType === FinanceType.OutFlow) {
          switch (this.headerTypeCode) {
            case "PO": {
              headerType = "";
              break;
            }
            case "CUS": {
              headerType = "";
              break;
            }
            case "PCR": {
              headerType = "pr";
              break;
            }
            case "PMR": {
              headerType = "pmr";
              break;
            }
            default: {
              headerType = "";
            }
          }
        }
        break;
      }
      case TransactionType.Invoice: {
        if (this.financeType === FinanceType.InFlow) {
          switch (this.headerTypeCode) {
            case "IV": {
              headerType = "";
              break;
            }
            case "CUS": {
              headerType = "";
              break;
            }
            case "IVDN": {
              headerType = "bl";
              break;
            }
            case "IVBN": {
              headerType = "bn";
              break;
            }
            case "BOG": {
              headerType = "bog";
              break;
            }
            default: {
              headerType = "";
            }
          }
        } else if (this.financeType === FinanceType.OutFlow) {
          switch (this.headerTypeCode) {
            case "EXP": {
              headerType = "";
              break;
            }
            case "CUS": {
              headerType = "";
              break;
            }
            case "EPN": {
              headerType = "pn";
              break;
            }
            case "ECN": {
              headerType = "ec";
              break;
            }
            case "BOL": {
              headerType = "bl";
              break;
            }
            default: {
              headerType = "";
            }
          }
        }
        break;
      }
      case TransactionType.Receipt: {
        if (this.financeType === FinanceType.InFlow) {
          switch (this.headerTypeCode) {
            case "RT": {
              headerType = "";
              break;
            }
            case "CUS": {
              headerType = "";
              break;
            }
            case "RN": {
              headerType = "rn";
              break;
            }
            case "CRT": {
              headerType = "cr";
              break;
            }
            default: {
              headerType = "";
            }
          }
        }
        break;
      }
      case TransactionType.TaxInvoice: {
        if (this.financeType === FinanceType.InFlow) {
          switch (this.headerTypeCode) {
            case "TIV": {
              headerType = "";
              break;
            }
            case "CUS": {
              headerType = "";
              break;
            }
            default: {
              headerType = "";
            }
          }
        }
        break;
      }
      case TransactionType.DailyJournal: {
        isDailyJournal = true;
        break;
      }
    }
    if (isDailyJournal) {
      if (replace) {
        location.replace(
          `${
            process.env.VUE_APP_PeakEngine
          }Account/RecordVoucher?emi=${this.getMerchantDetail.merchantId.PeakEncryption()}&eii=${this.transactionId.PeakEncryption()}`
        );
      } else {
        window.open(
          `${
            process.env.VUE_APP_PeakEngine
          }Account/RecordVoucher?emi=${this.getMerchantDetail.merchantId.PeakEncryption()}&eii=${this.transactionId.PeakEncryption()}`
        );
      }
    } else {
      if (replace) {
        location.replace(
          `${
            process.env.VUE_APP_PeakEngine
          }Pdf?emi=${this.getMerchantDetail.merchantId.PeakEncryption()}&eti=${this.transactionId.PeakEncryption()}&eii=${this.transactionType.PeakEncryption()}&ehi=${headerType}`
        );
      } else {
        window.open(
          `${
            process.env.VUE_APP_PeakEngine
          }Pdf?emi=${this.getMerchantDetail.merchantId.PeakEncryption()}&eti=${this.transactionId.PeakEncryption()}&eii=${this.transactionType.PeakEncryption()}&ehi=${headerType}`
        );
      }
    }
  }
  public RedirectToDocumentDetail() {
    let financeType = "";
    let documentName = "";
    let isDailyJournal = false;
    let isTaxDocument = false;
    let isContactEnvelope = false;
    let isExecutiveSummary = false;

    switch (this.transactionType) {
      case TransactionType.Quotation: {
        if (this.financeType === FinanceType.InFlow) {
          financeType = "income";
          documentName = "quotation";
        } else if (this.financeType === FinanceType.OutFlow) {
          financeType = "expense";
          documentName = "PO";
        }
        break;
      }
      case TransactionType.Invoice: {
        if (this.financeType === FinanceType.InFlow) {
          financeType = "income";
          documentName = "invoice";
        } else if (this.financeType === FinanceType.OutFlow) {
          financeType = "expense";
          documentName = "invoice";
        }
        break;
      }
      case TransactionType.Receipt: {
        if (this.financeType === FinanceType.InFlow) {
          financeType = "income";
          documentName = "receipt";
        }
        break;
      }
      case TransactionType.TaxInvoice: {
        if (this.financeType === FinanceType.InFlow) {
          financeType = "income";
          documentName = "taxinvoice";
        }
        break;
      }
      case TransactionType.BillingNote: {
        if (this.financeType === FinanceType.InFlow) {
          financeType = "income";
          documentName = "billingNote";
        } else {
          financeType = "expense";
          documentName = "billingNote";
        }
        break;
      }
      case TransactionType.CreditNote: {
        if (this.financeType === FinanceType.InFlow) {
          financeType = "income";
          documentName = "creditNote";
        } else {
          financeType = "expense";
          documentName = "creditNote";
        }
        break;
      }
      case TransactionType.DebitNote: {
        if (this.financeType === FinanceType.InFlow) {
          financeType = "income";
          documentName = "debitNote";
        } else {
          financeType = "expense";
          documentName = "debitNote";
        }
        break;
      }
      case TransactionType.DailyJournal: {
        isDailyJournal = true;
        break;
      }
      case TransactionType.WithholdingTax:
      case TransactionType.PP30:
      case TransactionType.Pnd1:
      case TransactionType.Pnd2:
      case TransactionType.Pnd3:
      case TransactionType.Pnd53: {
        isTaxDocument = true;
      }
      case DocumentType.Envelope: {
        isContactEnvelope = true;
      }
      case DocumentType.ExecutiveSummary: {
        isExecutiveSummary = true;
      }
    }

    if (isDailyJournal) {
      window.open(
        `${
          process.env.VUE_APP_PeakAccount
        }account/dailyJournalDetail?emi=${this.getMerchantDetail.merchantId.PeakEncryption()}&eii=${this.transactionId.PeakEncryption()}`
      );
    } else if (isTaxDocument) {
      switch (this.transactionType) {
        case TransactionType.WithholdingTax: {
          if (this.sourceType == TaxSourceType.PeakTax) {
            window.open(
              `${
                process.env.VUE_APP_PeakTax
              }withholding/withholdingDetail?emi=${this.getMerchantDetail.merchantId.PeakEncryption()}&eii=${this.transactionId.PeakEncryption()}`
            );
          }
          break;
        }
        case TransactionType.PP30: {
          window.open(
            `${
              process.env.VUE_APP_PeakTax
            }pp30/pp30Detail?emi=${this.getMerchantDetail.merchantId.PeakEncryption()}&epi=${this.transactionId.PeakEncryption()}`
          );
          break;
        }
        case TransactionType.Pnd1: {
          window.open(
            `${
              process.env.VUE_APP_PeakTax
            }pnd/pnd1Detail?emi=${this.getMerchantDetail.merchantId.PeakEncryption()}&epi=${this.transactionId.PeakEncryption()}&epti=${PndType.PND1.PeakEncryption()}`
          );
          break;
        }
        case TransactionType.Pnd2: {
          window.open(
            `${
              process.env.VUE_APP_PeakTax
            }pnd/pnd2Detail?emi=${this.getMerchantDetail.merchantId.PeakEncryption()}&epi=${this.transactionId.PeakEncryption()}&epti=${PndType.PND2.PeakEncryption()}`
          );
          break;
        }
        case TransactionType.Pnd3: {
          window.open(
            `${
              process.env.VUE_APP_PeakTax
            }pnd/pnd3Detail?emi=${this.getMerchantDetail.merchantId.PeakEncryption()}&epi=${this.transactionId.PeakEncryption()}&epti=${PndType.PND3.PeakEncryption()}`
          );
          break;
        }
        case TransactionType.Pnd53: {
          window.open(
            `${
              process.env.VUE_APP_PeakTax
            }pnd/pnd53Detail?emi=${this.getMerchantDetail.merchantId.PeakEncryption()}&epi=${this.transactionId.PeakEncryption()}&epti=${PndType.PND53.PeakEncryption()}`
          );
          break;
        }
      }
    } else if (isContactEnvelope) {
      window.open(
        `${
          process.env.VUE_APP_PeakAccount
        }contact/detail?emi=${this.getMerchantDetail.merchantId.PeakEncryption()}&eci=${this.transactionId.PeakEncryption()}`
      );
    } else if (isExecutiveSummary) {
      window.open(
        `${
          process.env.VUE_APP_PeakBoard
        }executiveSummaryDetail?emi=${this.getMerchantDetail.merchantId.PeakEncryption()}&eesi=${this.transactionId.PeakEncryption()}`
      );
    } else {
      window.open(
        `${
          process.env.VUE_APP_PeakAccount
        }${financeType}/${documentName}Detail?emi=${this.getMerchantDetail.merchantId.PeakEncryption()}&eii=${this.transactionId.PeakEncryption()}`
      );
    }
  }
}
